(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ?👉 Sticky Header (preservado de Dawn) ?👉 */
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() { this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.removeEventListener('scroll', this.onScrollHandler); }
    createObserver() { let o = new IntersectionObserver((e, obs) => { this.headerBounds = e[0].intersectionRect; obs.disconnect(); }); o.observe(this.header); }
    onScroll() {
      const s = window.pageYOffset || document.documentElement.scrollTop;
      if (s > this.currentScrollTop && s > this.headerBounds.bottom) { this.header.classList.add('scrolled-past-header'); if (!this.preventHide) requestAnimationFrame(this.hide.bind(this)); }
      else if (s < this.currentScrollTop && s > this.headerBounds.bottom) { this.header.classList.add('scrolled-past-header'); if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this)); else { window.clearTimeout(this.isScrolling); this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66); requestAnimationFrame(this.hide.bind(this)); } }
      else if (s <= this.headerBounds.top) { this.header.classList.remove('scrolled-past-header'); requestAnimationFrame(this.reset.bind(this)); }
      this.currentScrollTop = s;
    }
    hide() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); }
    reveal() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset() { if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
  }
  customElements.define('sticky-header', StickyHeader);

  /* ?👉 Desktop mega-menu toggle ?👉 */
  document.querySelectorAll('.sfym-nav__item[data-menu]').forEach(item => {
    const btn = item.querySelector('button.sfym-nav__link');
    if (!btn) return;
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const wasOpen = item.classList.contains('is-open');
      document.querySelectorAll('.sfym-nav__item.is-open').forEach(i => { i.classList.remove('is-open'); i.querySelector('button')?.setAttribute('aria-expanded','false'); });
      if (!wasOpen) { item.classList.add('is-open'); btn.setAttribute('aria-expanded','true'); }
    });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.sfym-nav__item')) document.querySelectorAll('.sfym-nav__item.is-open').forEach(i => { i.classList.remove('is-open'); i.querySelector('button')?.setAttribute('aria-expanded','false'); });
  });

  /* ?👉 Mobile drawer ?👉 */
  const hamburger = document.getElementById('sfym-hamburger-btn');
  const drawer = document.getElementById('sfym-drawer');
  const overlay = document.getElementById('sfym-drawer-overlay');
  const closeBtn = document.getElementById('sfym-drawer-close');
  function openDrawer() { document.querySelectorAll('.sfym-drawer__item[data-accordion]').forEach(function(i){ i.classList.remove('is-open'); }); drawer.classList.add('is-active'); overlay.classList.add('is-active'); hamburger.setAttribute('aria-expanded','true'); document.body.style.overflow='hidden'; }
  function closeDrawer() { drawer.classList.remove('is-active'); overlay.classList.remove('is-active'); hamburger.setAttribute('aria-expanded','false'); document.body.style.overflow=''; }
  if (hamburger) hamburger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* ?👉 Mobile accordion ?👉 */
  document.querySelectorAll('.sfym-drawer__item[data-accordion]').forEach(item => {
    const btn = item.querySelector('button.sfym-drawer__link');
    if (btn) btn.addEventListener('click', () => { item.classList.toggle('is-open'); });
  });

  /* ?👉 Buscador predictivo ?👉 */
  const sfymSearchOverlay = document.getElementById('sfym-search-overlay');
  const sfymSearchInput   = document.getElementById('sfym-search-input');
  const sfymSearchResults = document.getElementById('sfym-search-results');
  const sfymSearchFooter  = document.getElementById('sfym-search-footer');
  const sfymSearchAllLink = document.getElementById('sfym-search-all-link');

  function sfymOpenSearch() {
    sfymSearchOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => sfymSearchInput && sfymSearchInput.focus(), 120);
  }
  function sfymCloseSearch() {
    sfymSearchOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (sfymSearchInput) { sfymSearchInput.value = ''; }
    if (sfymSearchResults) sfymSearchResults.innerHTML = '<p class="sfym-search-hint">Escribe al menos 2 caracteres para buscar\u2026</p>';
    if (sfymSearchFooter) sfymSearchFooter.style.display = 'none';
  }

  const sfymSearchBtn = document.getElementById('sfym-search-btn');
  if (sfymSearchBtn) sfymSearchBtn.addEventListener('click', sfymOpenSearch);

  // Mobile search bar trigger (abre el mismo overlay)
  const sfymMobileSearchTrigger = document.getElementById('sfym-mobile-search-trigger');
  if (sfymMobileSearchTrigger) sfymMobileSearchTrigger.addEventListener('click', sfymOpenSearch);

  const sfymSearchClose = document.getElementById('sfym-search-close');
  if (sfymSearchClose) sfymSearchClose.addEventListener('click', sfymCloseSearch);

  if (sfymSearchOverlay) {
    sfymSearchOverlay.addEventListener('click', (e) => {
      if (e.target === sfymSearchOverlay) sfymCloseSearch();
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') sfymCloseSearch();
  });

  let sfymSearchTimer = null;
  function sfymFormatMoney(amount) {
    // /search/suggest.json devuelve el precio ya en la moneda (no en centavos)
    return 'S/ ' + parseFloat(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function sfymDoSearch(q) {
    if (q.length < 2) {
      sfymSearchResults.innerHTML = '<p class="sfym-search-hint">Escribe al menos 2 caracteres para buscar\u2026</p>';
      sfymSearchFooter.style.display = 'none';
      return;
    }
    sfymSearchResults.innerHTML = '<p class="sfym-search-hint">Buscando\u2026</p>';
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
      .then(r => r.json())
      .then(data => {
        const products = data.resources && data.resources.results && data.resources.results.products || [];
        if (!sfymSearchInput || sfymSearchInput.value.trim() !== q) return;
        if (products.length === 0) {
          sfymSearchResults.innerHTML = '<p class="sfym-search-hint">Sin resultados para "' + q + '"</p>';
          sfymSearchFooter.style.display = 'none';
          return;
        }
        sfymSearchResults.innerHTML = products.map(p => {
          const img = p.featured_image && p.featured_image.url
            ? '<img src="' + p.featured_image.url + '&width=96" alt="" loading="lazy">'
            : '<div class="sfym-search-result-item__img-placeholder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:20px;height:20px"><rect x="3" y="3" width="18" height="18" rx="3"/><path d="m3 9 4-4 4 4 4-4 4 4"/><circle cx="8" cy="15" r="2"/></svg></div>';
          const price = p.price ? sfymFormatMoney(p.price) : '';
          return '<a class="sfym-search-result-item" href="' + p.url + '">' + img + '<div class="sfym-search-result-item__info"><div class="sfym-search-result-item__title">' + p.title + '</div><div class="sfym-search-result-item__price">' + price + '</div></div></a>';
        }).join('');
        sfymSearchAllLink.href = '/search?type=product&q=' + encodeURIComponent(q);
        sfymSearchFooter.style.display = 'flex';
      })
      .catch(() => {
        sfymSearchResults.innerHTML = '<p class="sfym-search-hint">Error al buscar. Int\u00e9ntalo de nuevo.</p>';
      });
  }

  if (sfymSearchInput) {
    sfymSearchInput.addEventListener('input', () => {
      clearTimeout(sfymSearchTimer);
      const q = sfymSearchInput.value.trim();
      sfymSearchTimer = setTimeout(() => sfymDoSearch(q), 280);
    });
    sfymSearchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const q = sfymSearchInput.value.trim();
        if (q) window.location.href = '/search?type=product&q=' + encodeURIComponent(q);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
